import { useEffect, useState } from 'react'
import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import { betkoPopupWithAction } from '../../utils/BetkoPopupModal'
import { areAllFieldsFilled } from '../../utils/calculationDataValidation'
const OdbranaTiketa = () => {
  const [error, setError] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState({
    values: {
      odds: ['', ''],
      stakes: ['', ''],
    },
    results: {
      oldTicketValues: ['', ''],
      newTicketValues: ['', ''],
    },
  })
  const [showInputArea, setShowInputArea] = useState(true)

  const allInputsFilled = areAllFieldsFilled(data.values)

  useEffect(() => {
    if (allInputsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allInputsFilled])

  const calculateProfit = () => {
    const [mainOdds, defenderOdds] = data.values.odds.map(Number)
    const [mainStakes, defenderStakes] = data.values.stakes.map(Number)

    const noBonusProfitOld = mainOdds * mainStakes
    const totalProfitOld = noBonusProfitOld - (mainStakes + defenderStakes)

    const noBonusProfitNew = defenderOdds * defenderStakes
    const totalProfitNew = noBonusProfitNew - (mainStakes + defenderStakes)

    setData((prev) => ({
      ...prev,
      results: {
        oldTicketValues: [noBonusProfitOld, totalProfitOld],
        newTicketValues: [noBonusProfitNew, totalProfitNew],
      },
    }))
  }

  const clearFields = () => {
    setData({
      values: {
        odds: ['', ''],
        stakes: ['', ''],
      },
      results: {
        oldTicketValues: ['', ''],
        newTicketValues: ['', ''],
      },
    })
    setShowInputArea(true)
  }

  const toggleInputArea = () => {
    if (!showInputArea) {
      clearFields()
      return
    } else {
      calculateProfit()
    }

    setShowInputArea((prev) => !prev)
  }

  const resultFieldsLabels = ['Dobitak bez bonusa', 'Ukupan dobitak']

  useEffect(() => {
    if (error) {
      betkoPopupWithAction(
        'Greška',
        'Molimo proverite da li su svi podaci ispravno uneti i ponovo pokušajte.'
      )
    }
  }, [error])

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={'Odbrana tiketa'} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={toggleInputArea} disabled={disabled}>
            {showInputArea ? 'Prikaži rezultate' : 'Unesi obračunske podatke'}
          </button>
        </div>

        {showInputArea && (
          <>
            <div className={classesK.sectionTitle}>
              Upiši kvote za ishod tiketa
            </div>
            <OddsCalculator
              data={data.values}
              setData={setData}
              field='odds'
              labelPrefix={['Kvote za osnovni tiket', 'Kvote za odbranu']}
              type={['number', 'number']}
              min={['1', '0.01']}
              step={['1', '0.01']}
              setError={setError}
              rows={2}
            />
            <div className={classesK.sectionTitle}>Unesi uloge</div>
            <OddsCalculator
              data={data.values}
              setData={setData}
              field='stakes'
              labelPrefix={['Ulog za osnovni tiket', 'Ulog za odbranu']}
              type={['number', 'number']}
              min={['1', '0.1']}
              step={['1', '0.1']}
              setError={setError}
              rows={2}
            />
          </>
        )}
        {!showInputArea && (
          <div className={classesK.sectionResults}>
            <ResultsSection
              title='Odigrani tiket'
              subtitle={'Obračunati podaci'}
              results={data?.results.oldTicketValues}
              names={resultFieldsLabels}
              allowNegative={true}
            />
            <ResultsSection
              title='Novi tiket'
              subtitle={'Obračunati podaci'}
              results={data?.results.newTicketValues}
              names={resultFieldsLabels}
              allowNegative={true}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default OdbranaTiketa
